import API from "@/API";

const actions = {
  async block({ commit }, { account_id, description, operation }) {
    try {
      return await API.Professionals.block(account_id, description, operation);
    } catch (e) {
      throw "Tivemos um problema e não foi possível bloquear a conta do profissional!";
    }
  },

  async unblock({ commit }, { account_id, description, operation }) {
    try {
      return await API.Professionals.unblock(
        account_id,
        description,
        operation
      );
    } catch (e) {
      throw "Tivemos um problema e não foi possível desbloquear a conta do profissional!";
    }
  },

  async deactivate({ commit }, { account_id, description, operation }) {
    try {
      return await API.Professionals.deactivate(
        account_id,
        description,
        operation
      );
    } catch (e) {
      throw "Tivemos um problema e não foi possível desativar a conta do profissional!";
    }
  },

  async activate({ commit }, { account_id, description }) {
    try {
      return await API.Professionals.activate(account_id, description);
    } catch (e) {
      throw "Tivemos um problema e não foi possível ativar a conta do profissional!";
    }
  },

  async createPGAOnGateway({ commit }, account_id) {
    try {
      return await API.Professionals.createPGAOnGateway(account_id);
    } catch (e) {
      throw "Tivemos um problema e não foi possível criar conta do profissional no meio de pagamento!";
    }
  },

  async succesBackgroundCheck({ commit }, professional_id) {
    try {
      return await API.Professionals.successBackgroundCheck(professional_id);
    } catch (e) {
      throw "Tivemos um problema e não foi possível aprovar os antecedentes!";
    }
  },

  async succesValidateDocuments({ commit }, professional_id) {
    try {
      return await API.Professionals.succesValidateDocuments(professional_id);
    } catch (e) {
      throw "Tivemos um problema e não foi possível validar os documentos!";
    }
  },

  async askForDocuments({ commit }, professional_id) {
    try {
      await API.Professionals.askForDocuments(professional_id);
    } catch (e) {
      throw e;
    }
  },

  async requestDocumentsValidation({ commit }, professional_id) {
    try {
      return await API.Professionals.requestDocumentsValidation(
        professional_id
      );
    } catch (e) {
      throw "Tivemos um problema para solicitar a validação dos documentos!";
    }
  },

  async requestBackgroundCheck({ commit }, professional_id) {
    try {
      return await API.Professionals.requestBackgroundCheck(professional_id);
    } catch (e) {
      throw "Tivemos um erro ao verificar os antecedentes!";
    }
  },

  async denyAccess({ commit }, professional_id) {
    try {
      return await API.Professionals.denyAccess(professional_id);
    } catch (_) {
      throw "Tivemos um erro ao bloquear o acesso do profissional";
    }
  },

  async startTraining({ commit }, professional_id) {
    try {
      return await API.Professionals.approveOnTraining(professional_id);
    } catch (_) {
      throw "Tivemos um erro ao iniciar o treinamento do profissional";
    }
  },
  async approveOnTraining({ commit }, professional_id) {
    try {
      return await API.Professionals.approveOnTraining(professional_id);
    } catch (_) {
      throw "Tivemos um erro ao aprovar o profissional no treinamento.";
    }
  },
  async reproveOnTraining({ commit }, professional_id) {
    try {
      return await API.Professionals.reproveOnTraining(professional_id);
    } catch (_) {
      throw "Tivemos um erro ao reprovar o profisisonal no treinamento.";
    }
  }
};

export default {
  namespaced: true,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/professionals/management.js